import React, { useCallback, useMemo } from "react";
import cx from "classnames";
import {
  useIterableParts,
  useProductConfiguratorStore,
} from "components/_ProductConfigurator/store/ProductConfiguratorStore";

export default function OrderCodePart({
  part,
  activePart,
  activatePartItem,
  isConfigurationModalOpened,
  isFetchingOrderCodeProcess,
}) {
  const iterableParts = useIterableParts();
  const { setActivePartModal } = useProductConfiguratorStore.use.actions();

  const isDisabled = useMemo(() => {
    if (iterableParts === null) {
      return false;
    }

    if (!iterableParts?.length) {
      return true;
    }

    const iterablePart = iterableParts.find((p) => p.partKey === part.key);

    if (iterablePart) {
      return true;
    }

    return false;
  }, [iterableParts, part.key]);

  const handleClick = useCallback(
    (e) => {
      setActivePartModal(part?.key);
      if (!isDisabled) {
        activatePartItem(part, e, isConfigurationModalOpened);
      }
    },
    [
      part,
      setActivePartModal,
      isDisabled,
      activatePartItem,
      isConfigurationModalOpened,
    ],
  );

  return (
    <div
      className={cx("d-flex align-items-center h-100", {
        blockSkeletonBlue: isFetchingOrderCodeProcess,
      })}
    >
      <button
        className={cx("px-2 py-1 bg-white border h-100", {
          "cursor-not-allowed ": part.state === 3 || isDisabled,
          "cursor-pointer": !(part.state === 3 || isDisabled),
          "border-info bg-blue-50": activePart === part.key,
          "opacity-0": isFetchingOrderCodeProcess,
        })}
        disabled={part.state === 1 || part.state === 3 || isDisabled}
        onClick={handleClick}
      >
        {part.presentation || "\u00A0"}
      </button>
    </div>
  );
}
